import React from 'react';

import { useApplicationContext } from '@common/react/components/Core/Application/Application';

import { UserGroupType } from '@commonTuna/react/objects/UserGroup';

import { dashboardMenu, rootAdminMenu } from '@app/components/Routes/DashboardMenu';
import { useUserGroupContext } from '@app/components/UI/UserGroupProvider/UserGroupProvider';
import { User } from '@app/objects/User';

const getRootCheckAdminMenu = () => {
	const { getUser } = useApplicationContext();
	const { checkUserGroupAccess } = useUserGroupContext();

	const [rootCheckAdminMenu, setRootCheckAdminMenu] = React.useState(dashboardMenu);

	const user = getUser<User>();

	React.useEffect(() => {
		if (user && (user.root || checkUserGroupAccess(UserGroupType.PortalContentManager) || checkUserGroupAccess(UserGroupType.SystemBotTeacher))) {
			const notRootAdminMenu = dashboardMenu.concat(rootAdminMenu);

			setRootCheckAdminMenu(notRootAdminMenu);
		}
	}, [user]);

	return rootCheckAdminMenu;
};

export default getRootCheckAdminMenu;
